const INLINE_STYLES_TO_CLASSES_MAP = {
    'color': {
        // HLS Colors
        'hsl(0, 0%, 0%)': 'ck-color-black', // Black
        'hsl(0, 0%, 30%)': 'ck-color-dim-grey', // Dim Grey
        'hsl(0, 0%, 60%)': 'ck-color-grey', // Grey
        'hsl(0, 0%, 90%)': 'ck-color-light-grey', // Light Grey,
        'hsl(0, 0%, 100%)': 'ck-color-white', // White
        'hsl(0, 75%, 60%)': 'ck-color-red', // Red
        'hsl(30, 75%, 60%)': 'ck-color-orange', // Orange
        'hsl(60, 75%, 60%)': 'ck-color-yellow', // Yellow
        'hsl(90, 75%, 60%)': 'ck-color-light-green', // Light green
        'hsl(120, 75%, 60%)': 'ck-color-green', // Green
        'hsl(150, 75%, 60%)': 'ck-color-aquamarine', // Aquamarine
        'hsl(180, 75%, 60%)': 'ck-color-turquoise', // Turquoise
        'hsl(210, 75%, 60%)': 'ck-color-light-blue', // Light blue
        'hsl(240, 75%, 60%)': 'ck-color-blue', // Blue
        'hsl(270, 75%, 60%)': 'ck-color-purple', // Purpule

        // RGB Color
        'rgb(0, 0, 0)': 'ck-color-black', // Black
        'rgb(77, 77, 77)': 'ck-color-dim-grey', // Dim Grey
        'rgb(153, 153, 153)': 'ck-color-grey', // Grey,
        'rgb(230, 230, 230)': 'ck-color-light-grey', // Light Grey
        'rgb(255, 255, 255)': 'ck-color-white', // White
        'rgb(230, 77, 77)': 'ck-color-red', // Red
        'rgb(230, 153, 77)': 'ck-color-orange', // Orange
        'rgb(230, 230, 77)': 'ck-color-yellow', // Yellow
        'rgb(153, 230, 77)': 'ck-color-light-green', // Light green
        'rgb(77, 230, 77)': 'ck-color-green', // Green
        'rgb(77, 230, 153)': 'ck-color-aquamarine', // Aquamarine
        'rgb(77, 230, 230)': 'ck-color-turquoise', // Turquoise,
        'rgb(77, 153, 230)': 'ck-color-light-blue', // Light blue
        'rgb(77, 77, 230)': 'ck-color-blue', // Blue
        'rgb(153, 77, 230)': 'ck-color-purple' // Purpule
    },
    'font-family': {
        'Arial, Helvetica, sans-serif': 'ck-fm-arial',
        [`"Courier New", Courier, monospace`]: 'ck-fm-courier-new',
        'Georgia, serif': 'ck-fm-georgia',
        [`"Lucida Sans Unicode", "Lucida Grande", sans-serif`]: 'ck-fm-lucid-sans-unicode',
        'Tahoma, Geneva, sans-serif': 'ck-fm-tahoma',
        [`"Trebuchet MS", Helvetica, sans-serif`]: 'ck-fm-trebuchet-ms',
        [`"Times New Roman", Times, serif`]: 'ck-fm-times-new-roman',
        'Verdana, Geneva, sans-serif': 'ck-fm-verdana'
    },
    'background-color': {
        // HSL Colors
        'hsl(0, 0%, 90%)': 'ck-bg-light-gray', // Light Grey
        'hsl(0, 0%, 100%)': 'ck-bg-white', // White
        'hsl(90, 75%, 60%)': 'ck-bg-light-green', // Light Green
        'hsl(120, 75%, 60%)': 'ck-bg-bright-green', // Bright Green
        'hsl(240, 75%, 60%)': 'ck-bg-bright-blue', // Bright Blue
        'hsl(270, 75%, 60%)': 'ck-bg-purple', // Purple

        // RGB Colors
        'rgb(230, 230, 230)': 'ck-bg-light-gray', // Light Grey
        'rgb(255, 255, 255)': 'ck-bg-white', // White
        'rgb(153, 230, 77)': 'ck-bg-light-green', // Light Green
        'rgb(77, 230, 77)': 'ck-bg-bright-green', // Bright Green
        'rgb(77, 77, 230)': 'ck-bg-bright-blue', // Bright Blue
        'rgb(153, 77, 230)': 'ck-bg-purple', // Purple
    },
    'text-align': {
        'left': 'ck-text-left',
        'center': 'ck-text-center',
        'right': 'ck-text-right',
        'justify': 'ck-text-justify'
    }
};

const CLASS_TO_INLINE_STYLES_MAP = {
    'ck-color-black': { styleName: 'color', value: 'rgb(0, 0, 0)' },
    'ck-color-dim-grey': { styleName: 'color', value: 'rgb(77, 77, 77)' },
    'ck-color-grey': { styleName: 'color', value: 'rgb(153, 153, 153)' },
    'ck-color-light-grey': { styleName: 'color', value: 'rgb(230, 230, 230)' },
    'ck-color-white': { styleName: 'color', value: 'rgb(255, 255, 255)' },
    'ck-color-red': { styleName: 'color', value: 'rgb(230, 77, 77)' },
    'ck-color-orange': { styleName: 'color', value: 'rgb(230, 153, 77)' },
    'ck-color-yellow': { styleName: 'color', value: 'rgb(230, 230, 77)' },
    'ck-color-light-green': { styleName: 'color', value: 'rgb(153, 230, 77)' },
    'ck-color-green': { styleName: 'color', value: 'rgb(77, 230, 77)' },
    'ck-color-aquamarine': { styleName: 'color', value: 'rgb(77, 230, 153)' },
    'ck-color-turquoise': { styleName: 'color', value: 'rgb(77, 230, 230)' },
    'ck-color-light-blue': { styleName: 'color', value: 'rgb(77, 153, 230)' },
    'ck-color-blue': { styleName: 'color', value: 'rgb(77, 77, 230)' },
    'ck-color-purple': { styleName: 'color', value: 'rgb(153, 77, 230)' },
    'ck-fm-arial': { styleName: 'font-family', value: 'Arial, Helvetica, sans-serif' },
    'ck-fm-courier-new': { styleName: 'font-family', value: 'Courier New, Courier, monospace' },
    'ck-fm-georgia': { styleName: 'font-family', value: 'Georgia, serif' },
    'ck-fm-lucid-sans-unicode': { styleName: 'font-family', value: 'Lucida Sans Unicode, Lucida Grande, sans-serif' },
    'ck-fm-tahoma': { styleName: 'font-family', value: 'Tahoma, Geneva, sans-serif' },
    'ck-fm-trebuchet-ms': { styleName: 'font-family', value: 'Trebuchet MS, Helvetica, sans-serif' },
    'ck-fm-times-new-roman': { styleName: 'font-family', value: 'Times New Roman, Times, serif'},
    'ck-fm-verdana': { styleName: 'font-family', value: 'Verdana, Geneva, sans-serif' },
    'ck-bg-light-gray': { styleName: 'background-color', value: 'rgb(230, 230, 230)' },
    'ck-bg-white': { styleName: 'background-color', value: 'rgb(255, 255, 255)' },
    'ck-bg-light-green': { styleName: 'background-color', value: 'rgb(153, 230, 77)' },
    'ck-bg-bright-green': { styleName: 'background-color', value: 'rgb(77, 230, 77)' },
    'ck-bg-bright-blue': { styleName: 'background-color', value: 'rgb(77, 77, 230)' },
    'ck-bg-purple': { styleName: 'background-color', value: 'rgb(153, 77, 230)' },
    'ck-text-left': { styleName: 'text-align', value: 'left' },
    'ck-text-center': { styleName: 'text-align', value: 'center' },
    'ck-text-right': { styleName: 'text-align', value: 'right' },
    'ck-text-justify': { styleName: 'text-align', value: 'justify' }
};

export const transpileInlineStylesToClasses = (str: string): string => {
    if (!str || !str.includes('style')) {
        return str;
    }

    const div = document.createElement('div');
    const replacedString = str.replace(/style\s*=\s*"(.*?)"/gi, (match, styleContent) => {
        return `data-style="${styleContent}"`;
    });


    div.innerHTML = replacedString;

    // Process `data-style` attributes
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const elements = div.querySelectorAll('[data-style]') as NodeListOf<HTMLElement>;

    for (const element of elements) {
        const dataStyleContent = element.getAttribute('data-style');
        if (!dataStyleContent) continue;

        // Parse inline styles from the `data-style` attribute
        const styleEntries = dataStyleContent.split(';').map(entry => entry.trim()).filter(entry => entry);
        for (const styleEntry of styleEntries) {
            const [property, value] = styleEntry.split(':').map(part => part.trim());
            if (!property || !value) continue;

            if (property === 'font-family') {
                const fontFamily = INLINE_STYLES_TO_CLASSES_MAP['font-family']?.[value];
                if (fontFamily) {
                    element.setAttribute('data-font-family', fontFamily);
                }
            } else if (property === 'background-color') {
                const backgroundColor = INLINE_STYLES_TO_CLASSES_MAP['background-color']?.[value];
                if (backgroundColor) {
                    element.setAttribute('data-bg-color', backgroundColor);
                }
            } else {
                const current = INLINE_STYLES_TO_CLASSES_MAP[property];
                if (current && current[value]) {
                    element.classList.add(current[value]);
                }
            }
        }

        // Remove the processed `data-style` attribute
        element.removeAttribute('data-style');
    }

    return div.innerHTML;
};

export const transpileClassesToInlineStyles = (str: string): string => {
    if (!str) {
        return str;
    }
    const isPlainText = !/<[a-z][\s\S]*>/i.test(str);
    if (isPlainText) return str;

    const div = document.createElement('div');
    div.innerHTML = str;
     // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const elements = div.querySelectorAll('*') as NodeListOf<HTMLElement>;

    for (const element of elements) {
        const classList = Array.from(element.classList);

        // Apply inline styles from classes
        for (const property of classList) {
            if (CLASS_TO_INLINE_STYLES_MAP[property]) {
                element.style[CLASS_TO_INLINE_STYLES_MAP[property].styleName] = CLASS_TO_INLINE_STYLES_MAP[property].value;
                element.classList.remove(property);
            }
        }

        // Restore target="_blank" for links if missing
        if (element.tagName === 'A' && !element.hasAttribute('target')) {
            element.setAttribute('target', '_blank');
        }
        // Check for 'data-font-family' and update the class accordingly
        const dataFontFamily = element.getAttribute('data-font-family');

        if (dataFontFamily) {
            const classForFontFamily = CLASS_TO_INLINE_STYLES_MAP[dataFontFamily];

            if (classForFontFamily) {
                element.style['font-family'] = classForFontFamily.value;
            }

            element.removeAttribute('data-font-family');
        }

        // Check for 'data-bg-color' and update the class accordingly
        const dataBgColor = element.getAttribute('data-bg-color');

        if (dataBgColor) {
            const classForBgColor = CLASS_TO_INLINE_STYLES_MAP[dataBgColor];

            if (classForBgColor) {
                element.style['background-color'] = classForBgColor.value;
            }

            element.removeAttribute('data-bg-color');
        }
    }

    return div.innerHTML;
};
